import React from 'react';

const InvestmentSection: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#FFFFFF] pt-20 pb-20">
              <div className="">
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-32 gap-14">
            {/* Top Left - Why Invest Text */}
            <div className="space-y-10 order-1">
              <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
                Why Invest in Top Mining Stocks?
              </h2>
              <div className="space-y-4 ">
                <p  className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
                Top mining stocks, particularly junior mining stocks, offer <strong> unparalleled potential for investors willing to learn. </strong>These micro-cap companies, often focused on exploration and early-stage development, can skyrocket in value when a discovery is made—like Great Bear, Filo Mining or Snowline Gold. But finding the best mining stocks to buy now requires more than luck; it demands a <strong>proven process to focus on the winners and avoid the losers.</strong> At The Wealthy Miner, Robert's decades of experience trading millions for banks and advising hedge funds—give you the edge to identify mining companies to invest in for <strong>major return potential.</strong>
                </p>
              </div>
            </div>

            {/* Top Right - Person Examining Core Samples */}
            <div className="flex justify-center items-center order-2 h-full">
              <div className="relative w-full max-w-md xl:max-w-none h-full">
                <img 
                  src="/images/check.webp" 
                  alt="Geologist examining core samples" 
                  className="w-full h-full rounded-r-[25px] object-cover"
                />
              </div>
            </div>

            {/* Bottom Left - Core Samples with Pickaxe */}
            <div className="flex justify-center items-center order-4 lg:order-3 h-full">
              <div className="relative w-full max-w-md xl:max-w-none h-full">
                <img 
                  src="/images/hammer.webp" 
                  alt="Core samples with geological pickaxe" 
                  className="w-full h-full rounded-l-[25px] object-cover"
                />
              </div>
            </div>

            {/* Bottom Right - Robert's Insider Edge */}
            <div className="space-y-10 order-3 lg:order-4 mt-10 lg:mt-0">
              <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
                Robert Bruggeman's Insider Edge
              </h2>
              <div className="space-y-4 ">
                <p  className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
                Robert Bruggeman isn't your typical analyst. A former professional engineer and Mensa member, he's been the go-to "ideas guy" for one of Canada's top banks, and he now specializes in junior mining stocks. His crowning achievement? Growing AbraSilver from <strong>$5M to over $600M </strong>as Chairman—a <strong>10,000% increase.</strong> Since 2011, Robert has worked inside exploration companies, refining his ability to decode drill results, assess management teams, and pinpoint top mining stocks. Now, he's sharing his hedge fund-tested playbook to help you find mining shares to buy that could <strong>transform your portfolio.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default InvestmentSection;
